
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, Divider, Row, Col } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

import { fixedNumber } from '../../../util/util';

//基本字段
const baseFields = [{
    "text": "会员名称",
    "field": "contractName",
    disabled: true
}, {
    "text": "月份",
    "field": "month",
    disabled: true
}]

//物业字段
const rentFields = [{
    "text": "租金月份数",
    "field": "rentMonth",
    number: true,
    precision: 1,
    step:1,
    disabled: true,
    rules: [
        { required: true, message: '租金月份数不能为空!' },
    ]
}, {
    "text": "租金",
    "field": "rentFees",
    disabled: true
}, {
    "text": "减免租金",
    "field": "reduceRentFees",
    number: true,
    precision: 0,
}, {
    "text": "应收租金",
    "field": "totalRentFees",
    disabled: true
}, {
    "text": "备注",
    "field": "remark",
    rules: [
        { max: 64, message: '最多只能输入64个字符！' },
    ],
    "textarea": true
}];

//物业费字段
const propertyFields = [{
    "text": "物业费月份数",
    "field": "propertyFeesMonth",
    disabled : true,
    number: true,
    precision: 1,
    step:1,
    rules: [
        { required: true, message: '租金月份数不能为空!' },
    ]
}, {
    "text": "物业费",
    "field": "propertyFees",
    disabled: true
}
, {
    "text": "应收物业费",
    "field": "totalPropertyFees",
    disabled: true
}];


const waterFields = [
{
    "text": "固定水费",
    "field": "fixedWaterFees",
    number: true,
    precision: 1,
    step:0.1,
    disabled: true
}
,{
    "text": "表显水费",
    "field": "meterWaterFees",
    number: true,
    precision: 1,
    step:0.1,
}
,{
    "text": "应收水费",
    "field": "totalWaterFees",
    disabled: true,
    number: true,
    precision: 1,
    step:0.1,
}
];



const elecFields = [
{
    "text": "固定电费",
    "field": "fixedElectricityFees",
    disabled: true,
    number: true,
    precision: 1,
    step:0.1,
}
,{
    "text": "表显电费",
    "field": "meterElectricityFees",
    number: true,
    precision: 1,
    step:0.1,
}   
, {
    "text": "每月优惠",
    "field": "deduction", 
    disabled: true,
    number: true,
    precision: 1,
    step:0.1,
}
,{
    "text": "应收电费",
    "field": "totalElectricityFees",
    disabled: true,
    number: true,
    precision: 1,
    step:0.1,
}
];

class MarketRentEditForm extends Component {

    state = {}

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id;
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            http.post({
                url: '/tenantFees/saveTenantElecFees',
                data: values,
                success: (res) => {
                    let queryData = this.props.queryData;
                    queryData.notChangePage = true;
                    this.props.successCallback(queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    onChangeValue = (field, value) => {
        const { form, editData } = this.props;
        if (field === "rentMonth") {
            //计算租金
            let totalRentFees = value * editData.rentFees;
            let reduceRentFees = form.getFieldValue("reduceRentFees");
            totalRentFees = reduceRentFees == null ? totalRentFees : (totalRentFees - reduceRentFees);
            form.setFieldsValue({ "totalRentFees": totalRentFees });
        } else if (field === "reduceRentFees") {
            //计算租金
            let rentMonth = form.getFieldValue("rentMonth");
            let totalRentFees = rentMonth * editData.rentFees;
            totalRentFees = totalRentFees - value;
            form.setFieldsValue({ "totalRentFees": totalRentFees });
        } else if (field==="propertyFeesMonth") {
            //计算物业费
            let totalPropertyFees = value * editData.propertyFees;
            form.setFieldsValue({ "totalPropertyFees": totalPropertyFees });
        }  
        else if (field === "meterWaterFees") {
            //计算水费
            let totalWaterFees = value + editData["fixedWaterFees"];      
            form.setFieldsValue({ "totalWaterFees": totalWaterFees });
        } 
        else if (field === "meterElectricityFees") {
            //计算电费费
            let totalElectricityFees = value + editData["fixedElectricityFees"]-editData["deduction"];  
            form.setFieldsValue({ "totalElectricityFees": totalElectricityFees });
        } 
        else if (field === "currentDegree") {
            let sharedElecFees = form.getFieldValue("sharedElecFees");
            if (sharedElecFees == null || sharedElecFees === "") sharedElecFees = 0;
            this.calculationElec(value, sharedElecFees);
        } else if (field === "sharedElecFees") {
            let currentDegree = form.getFieldValue("currentDegree");
            if (currentDegree == null || currentDegree === "") currentDegree = 0;
            this.calculationElec(currentDegree, value);
        }
    }

    calculationElec = (currentDegree, sharedElecFees) => {
        const { form, editData } = this.props;
        let useDegree = (currentDegree - editData["lastDegree"]) * editData["electricityMultiple"];
        form.setFieldsValue({ "useDegree": useDegree });
        let elecFormula = editData.elecFormula;
        elecFormula = elecFormula.replace("[D]", useDegree);
        let electricityFees = fixedNumber(eval(elecFormula), 0) - editData.deduction;   //eslint-disable-line
        electricityFees += sharedElecFees;
        form.setFieldsValue({ "electricityFees": electricityFees });
    }

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field],
                        })(
                            item.number ?
                                <InputNumber disabled={item.disabled === true} precision={item.precision == null ? 2 : item.precision} min={0.00} step={item.step==null?1:item.step}
                                    max={999999999} style={{ width: '100%' }} onChange={this.onChangeValue.bind(this, item.field)} />
                                : item.textarea ? <Input.TextArea />
                                    : <Input disabled={item.disabled === true} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return this.createTwoCol(dom);
    };

    createTwoCol = (dom) => {
        let res = [];
        for (let i = 0; i < dom.length; i += 2) {
            let item = (<Row key={i}>
                <Col span={11}>{dom[i]}</Col>
                <Col span={11} offset={2}>
                    {(i + 1) < dom.length ? dom[i + 1] : ''}
                </Col>
            </Row>
            )
            res.push(item);
        }
        return res;
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={850}
                visible={visible}
                title="租户费用信息录入"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Row>
                        <Divider orientation="left">基本信息</Divider>
                        {this.createDom(baseFields)}
                    </Row>
                    <Row>
                        <Divider orientation="left">租金信息</Divider>
                        {this.createDom(rentFields)}
                    </Row>
                    <Row>
                        <Divider orientation="left">物业信息</Divider>
                        {this.createDom(propertyFields)}
                    </Row>
                    <Row>
                        <Divider orientation="left">水费信息</Divider>
                        {this.createDom(waterFields)}
                    </Row>
                    <Row>
                        <Divider orientation="left">电费信息</Divider>
                        {this.createDom(elecFields)}
                    </Row>
                </Form>
            </Modal>
        );
    }
}

const MarketRentEdit = Form.create()(MarketRentEditForm);

export default MarketRentEdit;